import React, { PropTypes } from 'react'
import styled from 'styled-components'
import CheckboxOn from '../../svg-icons/CheckboxOn'
import CheckboxOff from '../../svg-icons/CheckboxOff'
import { Metrics } from '../../Themes'

const propTypes = {
  handleChange: PropTypes.func,
  checked: PropTypes.bool,
  id: PropTypes.string
}

const Icon = styled.div`
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
`
const CheckboxContainer = styled.div`
  display: inline-block;
  span {
    padding-left: ${Metrics.margins.small};
  }
`

const Checkbox = props => {
  const { handleChange, id, checked } = props
  return (
    <CheckboxContainer {...props}>
      <Icon onClick={handleChange}>
        {checked ? <CheckboxOn id={id} /> : <CheckboxOff id={id} />}
      </Icon>
    </CheckboxContainer>
  )
}

Checkbox.propTypes = propTypes

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js